import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useRef } from "react";
import toast from "react-hot-toast";
import { FlaggedQuestion } from "../../types";
import { flagQuestion } from "../../utils/flagQuestion";

function FlagQuestionModal(props: {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  questionId: number;
  onFlagged?: (flaggedQuestion: FlaggedQuestion) => void;
}) {
  const handleClose = () => props.setShowModal(false);
  const formRef = useRef<HTMLFormElement>(null);

  return (
    <>
      <Modal show={props.showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Flag Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            ref={formRef}
            id="my-form"
            onSubmit={async (e) => {
              e.preventDefault();
              const formData = Object.fromEntries(
                new FormData(e.target as HTMLFormElement),
              );
              try {
                const responseData = await flagQuestion(
                  props.questionId,
                  String(formData.comment ?? ""),
                );

                props.onFlagged?.(responseData.flaggedQuestion);

                toast.success(
                  "Thank you! Your feedback has been received, and we will review it in due course.",
                );
              } catch (err) {
                toast.error(
                  "Sorry, error occurred saving your comment. Please try again or seek support.",
                );
              } finally {
                handleClose();
              }
            }}
          >
            <Form.Group className="mb-3">
              <p>
                Noticed a bad question? Please let us know what the issue is so
                we can fix the question.
              </p>
              <Form.Label>Enter comments</Form.Label>
              <Form.Control
                as="textarea"
                required
                name="comment"
                type="text"
                placeholder=""
                defaultValue=""
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" form="my-form" type="submit">
            Flag question
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FlagQuestionModal;
